import React, {useEffect, useState} from 'react';
import {addRowTblInput, mrbgStore} from './mrbgRedux';
import MrbgNumberInput from './MrbgNumberInput.jsx';
import MrbgCheckBox from './MrbgCheckBox.jsx';
import MrbgNormalInput from './MrbgNormalInput.jsx';

function MrbgTableInput({formID,tblID,influenceName,influenceOptions,columns,formStyle}){

  const
    [influenceOpt,setInfluenceOpt] = useState(mrbgStore.getState().mrbgVars[influenceOptions]),
    [influenceVal,setInfluenceVal] = useState(mrbgStore.getState().formsSettings[formID].STV[influenceName]),
    [tblInfo,setTblInfo] = useState(mrbgStore.getState().mrbgVars[tblID]||[]);

  useEffect(()=>{
    mrbgStore.dispatch(addRowTblInput({formID,tblID,colName:influenceName,colVal:influenceVal,colOpt:influenceOpt}))
  },[influenceVal])

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setTblInfo(mrbgStore.getState().mrbgVars[tblID]||[]);
      setInfluenceVal(mrbgStore.getState().formsSettings[formID].STV[influenceName])
      setInfluenceOpt(mrbgStore.getState().mrbgVars[influenceOptions])
    })
    return () =>unsubscribe();
  },[]);

  return(
    <div className={formStyle.tableFrame}>
      <table id={tblID} className={`${formStyle.mrbgTable} ${formStyle.mrbgTblInput}`}>
        <thead>
        <tr>
          <th className={formStyle.think}>ردیف</th>
          {
            Object.keys(columns).map((name,ind)=>{
              return <th key={ind}>{columns[name].label}</th>
            })
          }
        </tr>
        </thead>
        <tbody>
        {
          tblInfo.map((infoObj,ind)=>{
            return(
              <tr key={ind}>
                <td className={formStyle.think}>{ind+1}</td>
                {
                  Object.keys(columns).map((name,ind2)=>{
                    return(
                      <td key={ind2}>
                        <FieldType {...{formID,infoObj,name,colInfo:{...columns[name]},index:ind,formStyle}} />
                      </td>
                    )
                  })
                }
              </tr>
            )
          })
        }
        </tbody>
      </table>
    </div>
  )
}
function FieldType({formID,infoObj,name,colInfo,index,formStyle}){

  if( colInfo.type=='string' )
    return infoObj[name];

  else if( colInfo.type == 'mrbgNumberInput' )
    return <MrbgNumberInput {...{formID,name:`${name}[${index}]`,other:{...colInfo.other||{}},formStyle}} />

  else if( colInfo.type == 'mrbgCheckBox' )
    return <MrbgCheckBox {...{formID,name:`${name}[${index}]`,other:{...colInfo.other||{}},formStyle}} />

  else
    return <MrbgNormalInput {...{formID,...colInfo,name:name+'['+index+']',formStyle}} />
}
export default MrbgTableInput;